export default __webpack_public_path__ + "static/media/social.45990668.svg";